<form class="gallery-filters" [formGroup]="form">
  <div class="gallery-filters__category">
    <button
      type="button"
      app-button
      buttonTheme="light"
      buttonType="flat"
      *ngIf="category"
      class="gallery-filters__category-selection">{{ category.label }} <app-icon icon="caret-down"></app-icon>
    </button>

    <select class="input w-20 mr-2" formControlName="category" class="gallery-filters__category-select">
      <!-- Biodigital Categories -->
      <option *ngFor="let option of groupedOptions.category" [value]="option.id">
        <ng-container *ngIf="option.value !== ''">&nbsp;&nbsp;</ng-container>
        {{ option.label }}
      </option>
  
      <!-- Organization -->
      <option *ngFor="let option of groupedOptions.organization" [value]="option.id">
        {{ option.label }}
      </option>

      <!-- Collections -->
      <option *ngFor="let option of groupedOptions.collection" [value]="option.id">
        <ng-container *ngIf="option.value !== ''">&nbsp;&nbsp;</ng-container>
        {{ option.label }}
      </option>
  
      <!-- User -->
      <option *ngFor="let option of groupedOptions.user" [value]="option.id">{{ option.label }}</option>
    </select>
  </div>

  <input type="text" class="input gallery-filters__query" placeholder="Search..." formControlName="query">
</form>